import { qsa, add } from "@fluorescent/dom";
import { delayOffset } from "@/lib/animation";

const selectors = {
  productItems: ".animation--grid-item:not(.animation--grid-item-revealed)",
};

const classes = {
  itemRevealed: "animation--grid-item-revealed",
};

export default node => {
  setupProductItems();

  function setupProductItems() {
    const productItems = qsa(selectors.productItems, node);
    delayOffset(node, [selectors.productItems]);
    setTimeout(() => {
      add(productItems, classes.itemRevealed);
    }, 0);
  }

  return {
    setupProductItems,
  };
};
